export default {
  state: {
    mobileMainMenu: false,
    mobileCommonMenu: false,
    mobileLangSwitcher: false,
    mobileTagMenu: false,
    mobileSortingMenu: false,
    mobileAccountMenu: false,
    mobileFavoritesMenu: false,
    mobileCommonFavoritesMenu: false,
    mobileFilterMenu: false,
    mobileCropperMenu: false,
    mobileCartDeleteMenu: false,
    mobileCartMenu: null,
    mobileMenus: [],
  },
  getters: {
    MOBILE_MAIN_MENU: state => {
      return state.mobileMainMenu;
    },
    MOBILE_COMMON_MENU: state => {
      return state.mobileCommonMenu;
    },
    MOBILE_LANG_SWITCHER: state => {
      return state.mobileLangSwitcher;
    },
    MOBILE_TAG_MENU: state => {
      return state.mobileTagMenu;
    },
    MOBILE_SORTING_MENU: state => {
      return state.mobileSortingMenu;
    },
    MOBILE_ACCOUNT_MENU: state => {
      return state.mobileAccountMenu;
    },
    MOBILE_FAVORITES_MENU: state => {
      return state.mobileFavoritesMenu;
    },
    MOBILE_COMMON_FAVORITES_MENU: state => {
      return state.mobileCommonFavoritesMenu;
    },
    MOBILE_FILTER_MENU: state => {
      return state.mobileFilterMenu;
    },
    MOBILE_CROPPER_MENU: state => {
      return state.mobileCropperMenu;
    },
    MOBILE_MENUS: state => {
      return state.mobileMenus;
    },
    MOBILE_CART_MENU: state => {
      return state.mobileCartMenu;
    },
    MOBILE_CART_DELETE_MENU: state => {
      return state.mobileCartDeleteMenu;
    },
  },
  mutations: {
    SET_MOBILE_MAIN_MENU: (state, payload) => {
      state.mobileMainMenu = payload;
    },
    SET_MOBILE_COMMON_MENU: (state, payload) => {
      state.mobileCommonMenu = payload;
    },
    SET_MOBILE_LANG_SWITCHER: (state, payload) => {
      state.mobileLangSwitcher = payload;
    },
    SET_MOBILE_TAG_MENU: (state, payload) => {
      state.mobileTagMenu = payload;
    },
    SET_MOBILE_SORTING_MENU: (state, payload) => {
      state.mobileSortingMenu = payload;
    },
    SET_MOBILE_ACCOUNT_MENU: (state, payload) => {
      state.mobileAccountMenu = payload;
    },
    SET_MOBILE_FAVORITES_MENU: (state, payload) => {
      state.mobileFavoritesMenu = payload;
    },
    SET_MOBILE_COMMON_FAVORITES_MENU: (state, payload) => {
      state.mobileCommonFavoritesMenu = payload;
    },
    SET_MOBILE_FILTER_MENU: (state, payload) => {
      state.mobileFilterMenu = payload;
    },
    SET_MOBILE_CROPPER_MENU: (state, payload) => {
      state.mobileCropperMenu = payload;
    },
    SET_MOBILE_CART_MENU: (state, payload) => {
      state.mobileCartMenu = payload;
    },
    SET_MOBILE_CART_DELETE_MENU: (state, payload) => {
      state.mobileCartDeleteMenu = payload;
    },
    ADD_TO_MOBILE_MENUS: (state) => {
      state.mobileMenus.push(true);
    },
    REMOVE_FROM_MOBILE_MENUS: (state) => {
      if (state.mobileMenus.length > 0) {
        state.mobileMenus.splice(-1, 1);
      }
    },
    RESET_MOBILE_MENUS: (state) => {
      state.mobileMenus = [true];
    },
  },
  actions: {
    SET_MOBILE_MAIN_MENU: (context, mobileMainMenu) => {
      context.commit('SET_MOBILE_MAIN_MENU', mobileMainMenu);
      context.dispatch('OVERLAY_HANDLER', mobileMainMenu);
    },
    SET_MOBILE_LANG_SWITCHER: (context, mobileMainMenu) => {
      context.commit('SET_MOBILE_LANG_SWITCHER', mobileMainMenu);
      context.dispatch('OVERLAY_HANDLER', mobileMainMenu);
    },
    SET_MOBILE_TAG_MENU: (context, mobileSortingMenu) => {
      context.commit('SET_MOBILE_TAG_MENU', mobileSortingMenu);
      context.commit('SET_MOBILE_COMMON_MENU', mobileSortingMenu);
      context.dispatch('OVERLAY_HANDLER', mobileSortingMenu);
    },
    SET_MOBILE_SORTING_MENU: (context, mobileTagMenu) => {
      context.commit('SET_MOBILE_SORTING_MENU', mobileTagMenu);
      context.commit('SET_MOBILE_COMMON_MENU', mobileTagMenu);
      context.dispatch('OVERLAY_HANDLER', mobileTagMenu);
    },
    SET_MOBILE_ACCOUNT_MENU: (context, mobileAccountMenu) => {
      context.commit('SET_MOBILE_ACCOUNT_MENU', mobileAccountMenu);
      context.dispatch('OVERLAY_HANDLER', mobileAccountMenu);
    },
    SET_MOBILE_FAVORITES_MENU: (context, mobileFavoritesMenu) => {
      context.commit('SET_MOBILE_FAVORITES_MENU', mobileFavoritesMenu);
      context.dispatch('OVERLAY_HANDLER', mobileFavoritesMenu);
    },
    SET_MOBILE_COMMON_FAVORITES_MENU: (context, mobileCommonFavoritesMenu) => {
      context.commit('SET_MOBILE_COMMON_FAVORITES_MENU', mobileCommonFavoritesMenu);
      context.dispatch('OVERLAY_HANDLER', mobileCommonFavoritesMenu);
    },
    SET_MOBILE_FILTER_MENU: (context, mobileFilterMenu) => {
      context.commit('SET_MOBILE_FILTER_MENU', mobileFilterMenu);
      context.dispatch('OVERLAY_HANDLER', mobileFilterMenu);
    },
    SET_MOBILE_CROPPER_MENU: (context, mobileCropperMenu) => {
      context.commit('SET_MOBILE_CROPPER_MENU', mobileCropperMenu);
      context.dispatch('OVERLAY_HANDLER', mobileCropperMenu);
    },
    SET_MOBILE_CART_MENU: (context, product) => {
      context.commit('SET_MOBILE_CART_MENU', product);
      context.dispatch('OVERLAY_HANDLER', !!product);
    },
    SET_MOBILE_CART_DELETE_MENU: (context, product) => {
      context.commit('SET_MOBILE_CART_DELETE_MENU', product);
      context.dispatch('OVERLAY_HANDLER', !!product);
    },
    CLOSE_ALL_MOBILE_MENU: (context) => {
      context.commit('SET_MOBILE_MAIN_MENU', false);
      context.commit('SET_MOBILE_TAG_MENU', false);
      context.commit('SET_MOBILE_SORTING_MENU', false);
      context.commit('SET_MOBILE_ACCOUNT_MENU', false);
      context.commit('SET_MOBILE_FAVORITES_MENU', false);
      context.commit('SET_MOBILE_FILTER_MENU', false);
      context.commit('SET_MOBILE_CROPPER_MENU', false);
      context.commit('SET_MOBILE_CART_MENU', false);
      context.commit('SET_MOBILE_CART_DELETE_MENU', false);

      context.commit('RESET_MOBILE_MENUS');
      context.dispatch('OVERLAY_HANDLER', false);
    },
    OVERLAY_HANDLER: (context, data) => {
      context.commit(data ? 'ADD_TO_MOBILE_MENUS' : 'REMOVE_FROM_MOBILE_MENUS');

      /*const condition = context.getters.MOBILE_MENUS.length > 0;

      document.documentElement.style.overflow = condition
          ? 'hidden' : 'visible';
      document.body.style.overflow = condition
          ? 'hidden' : 'visible';

      document.documentElement.style.position = condition
          ? 'relative' : 'static';
      document.body.style.position = condition
          ? 'relative' : 'static';

      document.documentElement.style.height = condition
          ? '100%' : 'auto';
      document.body.style.height = condition
          ? '100%' : 'auto';*/
    },
  },
};